export default __webpack_public_path__ + "static/media/eco2.98b0666c.jpg";